import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ManageUserPermissionsComponent } from "./manage-user-permissions/manage-user-permissions.component";
import { ViewUpdatedUserPermissionsComponent } from "./view-updated-user-permissions/view-updated-user-permissions.component";
import { CreateResourceComponent } from "./create-resource/create-resource.component";

@Component({
  selector: "app-manage-permissions-wrapper",
  templateUrl: "./manage-permissions-wrapper.component.html",
  styleUrls: ["./manage-permissions-wrapper.component.scss"],
})
export class ManagePermissionsWrapperComponent implements OnInit {
  @Input("pageData") pageData;
  @ViewChild(ManageUserPermissionsComponent)
  private manageUserPermissionsComponent: ManageUserPermissionsComponent;

  selected = 1;

  desiredComponent: any = ManageUserPermissionsComponent;

  constructor() {}

  ngOnInit() {}

  assignComponent(component) {
    if (component === "manageUserPermissionsComponent") {
      this.selected = 1;
      this.desiredComponent = ManageUserPermissionsComponent;
    } else if (component === "viewUpdatedUserPermissionsComponent") {
      this.selected = 2;
      this.desiredComponent = ViewUpdatedUserPermissionsComponent;
    } else if (component === "addNewPermissionsComponent") {
      this.selected = 3;
      this.desiredComponent = CreateResourceComponent;
    }
  }
}
